<template>
  <div class="menuContainer">
    <el-aside :width="isCollapse ? '4rem' : '11.25rem'">
      <div class="logo" :style="{ width: isCollapse ? '4rem' : '11.25rem' }">
        <a href="#">
          <img class="logoImg" src="@/assets/imgs/logo.png" alt="" />
          <p v-if="!isCollapse">昌恩<span class="orangeTxt">智</span>控</p>
        </a>
      </div>

      <!-- 动画效果 -->
      <transition name="el-fade-in-linear">
        <!-- menu -->
        <!-- :default-active="defaultActive" -->
        <!-- :default-active="$route.path" -->
        <!-- logo -->

        <el-menu
          :unique-opened="true"
          style="border: none"
          :collapse-transition="true"
          :default-active="defaultActive"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          :router="true"
          @select="handleSelect"
        >
          <!-- 无子菜单数据渲染 -->
          <el-menu-item
            v-for="item in noChildren"
            :key="item.name"
            :index="item.name"
            @click="selectMenu"
          >
            <i :class="`el-icon-${item.icon}`"></i>
            <span slot="title" class="menu-name">{{ item.label }}</span>
          </el-menu-item>

          <!-- 有子菜单数据渲染 -->
          <!-- 渲染一级菜单 -->
          <el-submenu
            v-for="item in hasChildren"
            :index="item.label"
            :key="item.label"
            :class="isCollapse ? 'packUp' : ''"
          >
            <template slot="title">
              <i :class="`el-icon-${item.icon}`"></i>
              <span>{{ item.label }}</span>
            </template>
            <!-- <p ref="downIcon" class="el-icon-arrow-down downIcon"></p> -->

            <!-- 渲染二级菜单 -->
            <el-menu-item-group
              v-for="subItem in item.children"
              :key="subItem.path"
            >
              <el-menu-item :index="subItem.path">
                <i :class="`el-icon-${subItem.icon}`"></i>
                {{ subItem.label }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </transition>
      <div class="botRadius">
        <i
          class="foldIcon"
          :class="{
            'el-icon-s-fold': isCollapse,
            'el-icon-s-unfold': !isCollapse
          }"
          @click="setCollapse"
        ></i>
      </div>
    </el-aside>
    <!-- 展开 -->
  </div>
</template>

<script>
export default {
  name: 'asidePage',
  data () {
    return {
      isCollapse: false,
      //   侧边栏菜单 数据结构
      menuList: [
        {
          id: 0,
          path: '/',
          name: 'home',
          label: '首页',
          icon: 's-home',
          url: 'Home/home'
        },
        {
          id: 1,
          path: '/systemMenu',
          name: 'systemMenu',
          label: '系统管理',
          // icon: 'odometer',
          icon: 's-tools',
          children: [
            {
              path: '/userManagement',
              name: 'centralair',
              label: '用户管理',
              icon: 'user-solid',
              url: 'userManagement/userManagement',
              roles: ['admin']
            },
            {
              path: '/orther',
              name: 'centralair',
              label: '其他',
              icon: 's-goods',
              url: 'orther/orther'
            }
          ]
        }
        // {
        //   id: 2,
        //   path: '/dataCenter',
        //   name: 'dataCenter',
        //   label: '数据中心',
        //   icon: 's-platform',
        //   url: 'DataCenter/dataCenter',
        //   children: [
        //     {
        //       path: '/electricdata',
        //       name: 'electricdata',
        //       label: '电能数据',
        //       icon: 's-platform',
        //       url: 'DataCenter/electricdata'
        //     },
        //     {
        //       path: '/reaitimedata',
        //       name: 'reaitimedata',
        //       label: '实时数据',
        //       icon: 's-platform',
        //       url: 'DataCenter/reaitimedata'
        //     },
        //     {
        //       path: '/historydata',
        //       name: 'historydata',
        //       label: '历史数据',
        //       icon: 's-platform',
        //       url: 'DataCenter/historydata'
        //     }
        //   ]
        // },
      ],

      // defaultActive: 'home'
      defaultActive: ''
    }
  },
  watch: {
    $route (newV, oldV) {
      this.handleSelect(this.defaultActive)
      if (newV.path == '/home') {
        this.defaultActive = 'home'
      }
    }
  },
  mounted () {
    console.log('当前路由', this.$route.path)
    if (this.$route.path == '/home') {
      this.defaultActive = 'home'
    } else if (this.$route.path.includes('userManagement')) {
      this.defaultActive = '/userManagement'
    } else {
      this.defaultActive = this.$route.path
    }
  },
  onMounted () {},
  beforeMount () {},
  computed: {
    // 过滤出没有子菜单数据
    noChildren () {
      return this.menuList.filter(item => !item.children)
    },
    // 过滤出有子菜单数据
    hasChildren () {
      // return this.menuList.filter(item => item.children)

      let userName = JSON.parse(localStorage.getItem('userInfo')).userName
      console.log('当前账户：', userName)

      let tempData = this.menuList.filter(item => item.children)

      if (userName == 'admin') {
        return this.menuList.filter(item => item.children)
      } else {
        return tempData
          .map(item => {
            if (item.children) {
              // 筛选出拥有 roles 字段的子菜单项
              const filteredChildren = item.children.filter(
                child => !child.roles
              )
              return {
                ...item, // 保留原有的菜单项属性
                children: filteredChildren // 替换为筛选后的子菜单
              }
            }
            return item // 不含子菜单则直接返回原项
          })
          .filter(item => item.children?.length > 0 || !item.children) // 过滤掉没有有效子菜单的项
      }
    }
  },

  methods: {
    handleSelect (index) {
      this.defaultActive = index
    },
    handleOpen (index, val) {
      // console.log('open', index)
    },
    handleClose () {
      // const el = document.getElementsByClassName('el-submenu__icon-arrow')
      // for (let i = 0; i < el.length; i++) {
      //   el[i].style.opacity = 0
      // }
    },
    setCollapse () {
      this.isCollapse = !this.isCollapse
    },
    selectMenu (item) {
      console.log('selectMenu', item.index)
      if (item.index === 'home') {
        // console.log('点击首页')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@bgc: #000f39;
.menuContainer {
  height: 100vh;
}
.el-aside {
  height: 100%;
  position: relative;
  background-color: rgb(@asideClour);
}
.logo {
  width: 100%;
  height: 56px;
  line-height: 56px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ffffff88;
}
.logo a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f7f7ff;
}
.logo a p {
  padding-left: 10px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-weight: 700;
}
.logo .orangeTxt {
  color: #f39800;
}
.logo img {
  height: 42px;
  width: 42px;
  object-fit: contain;
}

.el-menu {
  padding: 6px;
  border-right: none;
  text-align: left;
  // height: calc(100% - 150px);
  border-bottom-right-radius: 10px;
  // min-height: calc(100% - 150px);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: rgb(@asideClour);
}
.el-menu-item {
  border-radius: 6px;
  color: rgb(@menuTextColor);
  background-color: rgb(@asideClour);
}

::v-deep .el-submenu .el-menu {
  border-radius: 6px;
  background-color: rgb(@asideClour);
}
::v-deep .el-submenu__title {
  border-radius: 6px;
  color: rgb(@menuTextColor);
  font-size: 14px !important;
  // padding: 0 14px !important;
}
.packUp ::v-deep .el-submenu__title {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-submenu__title:hover {
  border-radius: 6px;
  color: rgb(@menuTextColorHover);
  background-color: rgb(@menuTextColor);
}

.el-menu-item.is-active {
  // background: url('@/assets/imgs/menuClickBgc.png') no-repeat left;
  color: rgb(@menuTextColor);
  background-color: #007bff;
}
.el-menu-item:hover {
  color: rgb(@menuTextColorHover);
  background-color: rgb(@menuTextColor);
}
.el-submenu .el-menu-item:hover {
  color: rgb(@menuTextColorHover);
}
.el-submenu:last-child {
  margin-bottom: 60px !important;
}
// 右侧>符号
// ::v-deep .el-submenu__icon-arrow {
//   position: relative;
//   top: 60%;
//   left: -80px;
//   opacity: 0;
// }
// .downIcon {
//   margin-left: 20px;
// }

// 二级菜单缩进
::v-deep .el-submenu .el-menu-item {
  // padding: 0 20px !important;
  color: #ffffff88;
  //font-size: 16px;
}
.el-submenu {
  position: relative;
}

.el-submenu:last-child {
  margin-bottom: 40px;
}

.el-menu-item-group {
  background-color: rgb(@asideClour);
}

::v-deep .el-menu-item-group__title {
  padding: 0 0 0 26px;
}
::v-deep .el-tooltip {
  line-height: 56px;
}

.botRadius {
  width: 100%;
  height: 60px;
  line-height: 60px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  color: rgb(@baseColourTextColor);
  cursor: pointer;
  z-index: 1008611;
  // background-color: rgb(@asideClour);
  border-bottom-right-radius: 20px; //恢复 -- 滚动条样式
}

// 隐藏滚动条
.el-aside::-webkit-scrollbar {
  width: 0.5em; /* 设置滚动条宽度 */
  height: 0.5em; /* 设置滚动条高度 */
}

.el-aside::-webkit-scrollbar-thumb {
  background-color: transparent; /* 将滚动条拇指颜色设置为透明 */
}

// 设置滚动条样式
.el-menu::-webkit-scrollbar {
  width: 6px;
}
.el-menu::-webkit-scrollbar-thumb {
  border-radius: 20px;
  box-shadow: inset 0 0 5px rgba(43, 55, 89, 0.2);
  background: rgba(43, 55, 89, 0.2);
}
.el-menu::-webkit-scrollbar-track {
  border-radius: 0px;
}
::v-deep .el-tooltip {
  padding: 0 14px !important;
}
</style>
